import axios from "axios";
import config from "@/libs/config.js";

const impressionSet = new Set();

function postEvent(payload) {
  const body = JSON.stringify(payload);
  const url = `${config.API_URL}/ads/events`;
  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: "application/json" });
    navigator.sendBeacon(url, blob);
    return;
  }
  axios.post(url, payload).catch(() => {});
}

export function trackAdImpression(ad, slot) {
  if (!ad?._id) return;
  const key = `${slot}:${ad._id}`;
  if (impressionSet.has(key)) return;
  impressionSet.add(key);
  postEvent({
    type: "impression",
    adId: ad._id,
    slot,
    page: window.location.pathname,
  });
}

export function trackAdClick(ad, slot) {
  if (!ad?._id) return;
  postEvent({
    type: "click",
    adId: ad._id,
    slot,
    page: window.location.pathname,
    url: ad.url,
  });
}
